import { CrossStorageClient } from "cross-storage";

let storage = new CrossStorageClient(
  process.env.VUE_APP_STORAGE_CLIENT,
  {
    timeout: 10000,
    frameId: process.env.VUE_APP_STORAGE_FRAME
  }
);

storage.getToken = function () {
  return storage.onConnect()
    .then(() => {
      return storage.get('token')
        .then(res => {
          return res;
        })
    });
};

storage.getRoles = function() {
  return storage.onConnect()
    .then(() => {
      return storage.get('roles')
        .then(res => {
          return JSON.parse(res);
        })
    });
};

export default storage;
